import React, { createContext, useContext, useState } from 'react'
import { Spin } from 'antd'
import '../styles/loading.scss'

interface LoadingContextData {
  isLoading: boolean
  setLoading: (loading: boolean) => void
}

const LoadingContext = createContext<LoadingContextData | undefined>(undefined)

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <LoadingContext.Provider value={{ isLoading, setLoading: setIsLoading }}>
      {isLoading && (
        <div className="loading-overlay">
          <Spin size="large" tip="Carregando..." />
        </div>
      )}
      {children}
    </LoadingContext.Provider>
  )
}

export const useLoading = (): LoadingContextData => {
  const context = useContext(LoadingContext)
  if (!context) {
    throw new Error('useLoading deve ser usado dentro de LoadingProvider')
  }
  return context
}
